export default __webpack_public_path__ + "static/vertical_rectangle_shadow_voyo-dd31352f1969bcbc8466d17e919820ea.gif";